import { render } from "./k-app-sidebar.vue?vue&type=template&id=7b763c98"
import script from "./k-app-sidebar.vue?vue&type=script&lang=js"
export * from "./k-app-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__